(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--faq"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-faq-section')){
  class StackFAQSection extends HTMLElement {
    constructor() {
      super();
      this.resizeTimeout = null;
      this.initialized = false;
      this.boundHandleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      // Security check with deferred initialization
      if(!window.stack?.isChecked||!window.stack.isChecked()){
        setTimeout(()=>{
          if(!window.stack?.check||window.stack.check()===false){
            this.remove();
          } else {
            this.init();
          }
        },100);
        return;
      }
      if(!window.stack?.check||window.stack.check()===false){
        this.remove();
        return;
      }

      // Initialize immediately if security check passes
      requestAnimationFrame(() => this.init());
    }

    init() {
      if (this.initialized) return;
      
      const faqQuestions = this.querySelectorAll('.stack--faq-question');
      if (faqQuestions.length === 0) return;

      // Set initial heights
      this.setHeights();

      // Setup resize listener
      window.addEventListener('resize', this.boundHandleResize);

      // Setup click handlers
      faqQuestions.forEach(question => {
        question.addEventListener('click', this.handleQuestionClick.bind(this));
      });

      this.initialized = true;
    }

    handleResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => this.setHeights(), 200);
    }

    setHeights() {
      const answers = this.querySelectorAll('.stack--faq-answer');
      answers.forEach(answer => {
        const inner = answer.querySelector('.stack--faq-answer-inner');
        if (!inner) return;
        
        if (answer.getAttribute('aria-hidden') === 'false') {
          answer.style.height = inner.offsetHeight + 'px';
        } else {
          answer.style.height = '0px';
        }
      });
    }

    handleQuestionClick(event) {
      const question = event.currentTarget;
      const expanded = question.getAttribute('aria-expanded') === 'true';
      const answerId = question.getAttribute('aria-controls');
      const answer = document.getElementById(answerId);
      if (!answer) return;
      
      const answerInner = answer.querySelector('.stack--faq-answer-inner');
      if (!answerInner) return;

      // Toggle current FAQ item
      question.setAttribute('aria-expanded', !expanded);
      answer.setAttribute('aria-hidden', expanded);

      // Smooth height animation
      if (expanded) {
        answer.style.height = '0px';
      } else {
        answer.style.height = answerInner.offsetHeight + 'px';
      }

      // Close other items (accordion behavior)
      if (!expanded) {
        const allQuestions = this.querySelectorAll('.stack--faq-question');
        allQuestions.forEach(otherQuestion => {
          if (otherQuestion !== question) {
            const otherAnswerId = otherQuestion.getAttribute('aria-controls');
            const otherAnswer = document.getElementById(otherAnswerId);
            if (!otherAnswer) return;

            otherQuestion.setAttribute('aria-expanded', 'false');
            otherAnswer.setAttribute('aria-hidden', 'true');
            otherAnswer.style.height = '0px';
          }
        });
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.boundHandleResize);
      this.initialized = false;
    }
  }

  customElements.define('stack-faq-section', StackFAQSection);
}

// Handle Shopify theme editor events
document.addEventListener('shopify:section:load', function(event) {
  if (event.detail.sectionId.includes('stack--faq')) {
    const section = document.querySelector('.stack--faq');
    if (section && section.tagName.toLowerCase() === 'stack-faq-section') {
      setTimeout(() => section.init(), 100);
    }
  }
});

document.addEventListener('shopify:section:select', function(event) {
  if (event.detail.sectionId.includes('stack--faq')) {
    const section = document.querySelector('.stack--faq');
    if (section && section.tagName.toLowerCase() === 'stack-faq-section') {
      section.init();
    }
  }
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--image-with-benefits"] && !Shopify.designMode) return;
  try {
    
(async()=>{
const el=document.querySelector('.stack--image-with-benefits');
if(!el)return;
if(!window.stack?.isChecked||!window.stack.isChecked()){setTimeout(()=>{if(!window.stack?.check||window.stack.check()===false){el.remove()}},100);return;}
if(!window.stack?.check||window.stack.check()===false){el.remove();return;}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--logo-slider"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-logo-slider-section')){
  class StackLogoSliderSection extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.resizeTimeout = null;
      this.boundHandleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      // Security check with deferred initialization
      if(!window.stack?.isChecked||!window.stack.isChecked()){
        setTimeout(()=>{
          if(!window.stack?.check||window.stack.check()===false){
            this.remove();
          } else {
            this.init();
          }
        },100);
        return;
      }
      if(!window.stack?.check||window.stack.check()===false){
        this.remove();
        return;
      }

      // Initialize immediately if security check passes
      requestAnimationFrame(() => this.init());
    }

    init() {
      if (this.initialized) return;
      
      const marquee = this.querySelector('.stack--logo-slider-marquee');
      const tracksContainer = this.querySelector('.stack--logo-slider-tracks-container');
      
      if (!marquee || !tracksContainer) return;
      
      if (window.getComputedStyle(document.documentElement).getPropertyValue('direction') === 'rtl') {
        marquee.classList.add('stack--logo-slider-rtl');
      }
      
      this.adjustTrackCount(tracksContainer);
      
      // Setup resize listener
      window.addEventListener('resize', this.boundHandleResize);
      
      this.initialized = true;
    }

    handleResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        const tracksContainer = this.querySelector('.stack--logo-slider-tracks-container');
        if (tracksContainer) {
          this.adjustTrackCount(tracksContainer);
        }
      }, 250);
    }

    adjustTrackCount(tracksContainer) {
      const existingTracks = tracksContainer.querySelectorAll('.stack--logo-slider-track');
      const firstTrack = existingTracks[0];
      
      if (!firstTrack) return;
      
      const screenWidth = window.innerWidth;
      const trackWidth = firstTrack.scrollWidth;
      const neededTracks = Math.max(3, Math.ceil((screenWidth * 2) / trackWidth));
      const currentTracks = existingTracks.length;
      
      if (neededTracks > currentTracks) {
        for (let i = currentTracks; i < neededTracks; i++) {
          const newTrack = firstTrack.cloneNode(true);
          newTrack.setAttribute('aria-hidden', 'true');
          
          newTrack.querySelectorAll('.stack--logo-slider-item').forEach(item => {
            item.removeAttribute('data-block-id');
            item.querySelectorAll('a').forEach(link => link.setAttribute('tabindex', '-1'));
            item.querySelectorAll('img').forEach(img => img.setAttribute('alt', ''));
          });
          
          tracksContainer.appendChild(newTrack);
        }
        this.resetAnimation(tracksContainer);
      }
      
      if (neededTracks < currentTracks) {
        for (let i = currentTracks - 1; i >= neededTracks; i--) {
          if (existingTracks[i] && i > 0) {
            existingTracks[i].remove();
          }
        }
        this.resetAnimation(tracksContainer);
      }
    }

    resetAnimation(tracksContainer) {
      const tracks = tracksContainer.querySelectorAll('.stack--logo-slider-track');
      tracks.forEach(track => {
        track.style.animation = 'none';
        track.offsetHeight;
        track.style.animation = null;
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.boundHandleResize);
      this.initialized = false;
    }
  }

  customElements.define('stack-logo-slider-section', StackLogoSliderSection);
}

// Handle Shopify theme editor events
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId.includes('stack--logo-slider')) {
      const section = document.querySelector('.stack--logo-slider');
      if (section && section.tagName.toLowerCase() === 'stack-logo-slider-section') {
        setTimeout(() => section.init(), 100);
      }
    }
  });
  
  document.addEventListener('shopify:section:unload', function(event) {
    if (event.detail.sectionId.includes('stack--logo-slider')) {
      const section = document.querySelector('.stack--logo-slider');
      if (section && section.tagName.toLowerCase() === 'stack-logo-slider-section') {
        section.disconnectedCallback();
      }
    }
  });
}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--stats-benefits"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-stats-benefits-section')){
  class StackStatsBenefitsSection extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.observer = null;
    }

    connectedCallback() {
      // Security check with deferred initialization
      if(!window.stack?.isChecked||!window.stack.isChecked()){
        setTimeout(()=>{
          if(!window.stack?.check||window.stack.check()===false){
            this.remove();
          } else {
            this.init();
          }
        },100);
        return;
      }
      if(!window.stack?.check||window.stack.check()===false){
        this.remove();
        return;
      }

      // Initialize immediately if security check passes
      requestAnimationFrame(() => this.init());
    }

    init() {
      if (this.initialized) return;
      
      const counters = this.querySelectorAll('.stack--stats-benefits-counter');
      const observerOptions = {
        threshold: 0.5,
        rootMargin: '0px 0px -50px 0px'
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !entry.target.dataset.animated) {
            this.animateCounter(entry.target);
            entry.target.dataset.animated = 'true';
          }
        });
      }, observerOptions);

      counters.forEach(counter => {
        this.observer.observe(counter);
      });

      this.initialized = true;
    }

    animateCounter(counter) {
      const from = parseInt(counter.dataset.from) || 0;
      const to = parseInt(counter.dataset.to) || 0;
      const duration = parseInt(counter.dataset.duration) || 2000;
      
      if (from === to) return;
      
      const startTime = performance.now();
      const difference = to - from;
      
      const updateCounter = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        
        const easeOut = 1 - Math.pow(1 - progress, 3);
        const currentValue = Math.round(from + (difference * easeOut));
        
        counter.textContent = currentValue;
        
        if (progress < 1) {
          requestAnimationFrame(updateCounter);
        } else {
          counter.textContent = to;
        }
      };
      
      requestAnimationFrame(updateCounter);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
      this.initialized = false;
    }
  }

  customElements.define('stack-stats-benefits-section', StackStatsBenefitsSection);
}

// Handle Shopify theme editor events
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId.includes('stack--stats-benefits')) {
      const section = document.querySelector('.stack--stats-benefits');
      if (section && section.tagName.toLowerCase() === 'stack-stats-benefits-section') {
        setTimeout(() => section.init(), 100);
      }
    }
  });
}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--testimonials"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-testimonials-section')){
  class StackTestimonialsSection extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.swiper = null;
    }

    connectedCallback() {
      // Security check with deferred initialization
      if(!window.stack?.isChecked||!window.stack.isChecked()){
        setTimeout(()=>{
          if(!window.stack?.check||window.stack.check()===false){
            this.remove();
          } else {
            this.init();
          }
        },100);
        return;
      }
      if(!window.stack?.check||window.stack.check()===false){
        this.remove();
        return;
      }

      // Initialize immediately if security check passes
      requestAnimationFrame(() => this.init());
    }

    init() {
      if (this.initialized) return;
      
      const layout = this.dataset.layout;
      
      if (layout === 'stack') {
        this.initStackViewMore();
      } else if (layout === 'slider') {
        this.initSwiperSlider();
      }

      this.initialized = true;
    }

    initStackViewMore() {
      const viewMoreBtn = this.querySelector('.stack--testimonials-view-more-btn');
      if (!viewMoreBtn) return;
      
      viewMoreBtn.addEventListener('click', () => {
        const hiddenCards = this.querySelectorAll('.stack--testimonials-card-hidden');
        hiddenCards.forEach(card => {
          card.classList.remove('stack--testimonials-card-hidden');
        });
        viewMoreBtn.parentElement.style.display = 'none';
      });
    }

    initSwiperSlider() {
      const swiperContainer = this.querySelector('.stack--testimonials-swiper');
      if (!swiperContainer) return;
      
      // Wait for Swiper library to load
      if (typeof Swiper === 'undefined') {
        setTimeout(() => this.initSwiperSlider(), 100);
        return;
      }
      
      // Initialize Swiper with configuration
      this.swiper = new Swiper('.stack--testimonials-swiper', {
        // Basic settings
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        speed: 600,
        // Navigation
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        centeredSlides: false,
        slidesPerView: 'auto',
        
        // Accessibility
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous testimonial',
          nextSlideMessage: 'Next testimonial',
          firstSlideMessage: 'This is the first testimonial',
          lastSlideMessage: 'This is the last testimonial',
        },
        
        // Keyboard control
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        
        // Touch/Swipe
        touchRatio: 1,
        touchAngle: 45,
        grabCursor: true,
        touchStartPreventDefault: false,
        
        // Effects
        effect: 'slide',
        fadeEffect: {
          crossFade: true,
        },
      });
    }

    disconnectedCallback() {
      // Cleanup Swiper instance
      if (this.swiper && this.swiper.destroy) {
        this.swiper.destroy(true, true);
      }
      this.initialized = false;
    }
  }

  customElements.define('stack-testimonials-section', StackTestimonialsSection);
}

// Handle Shopify theme editor events
document.addEventListener('shopify:section:load', function(event) {
  if (event.detail.sectionId.includes('stack--testimonials')) {
    const section = document.querySelector('.stack--testimonials');
    if (section && section.tagName.toLowerCase() === 'stack-testimonials-section') {
      setTimeout(() => section.init(), 100);
    }
  }
});

document.addEventListener('shopify:section:select', function(event) {
  if (event.detail.sectionId.includes('stack--testimonials')) {
    const section = document.querySelector('.stack--testimonials');
    if (section && section.tagName.toLowerCase() === 'stack-testimonials-section') {
      section.init();
    }
  }
});
})();

  } catch(e) { console.error(e); }
})();
})();
